<template>
  <div>
    <v-row dense class="mx-1">
      <v-btn v-if="hasRoleComprador || hasRoleRequisicao"
             color="primary" class="normal-btn-text rounded-tag-small elevation-0"
             link to="/mensagens/cadastro">
        <v-icon left>mdi-plus</v-icon>
        Mensagem Personalizada
      </v-btn>
      <v-spacer/>
      <v-btn icon @click="onClickRefresh">
        <v-icon left>mdi-refresh</v-icon>
      </v-btn>
      <px-mensagem-personalizada-filter @change="onChangeFilter"/>
      <px-search-text label="Busque pela mensagem ou código"
                      class="rounded-tag-small" v-model="searchText"
                      style="max-width: 400px"
                      :on-search="onChangeSearchText"/>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MensagemPersonalizadaFilter from './MensagemPersonalizadaFilter.vue';

export default {
  props: {
    onClickRefresh: {
      type: Function,
      required: true,
    },
    onChangeFilter: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ...mapGetters('listagemMensagens', ['stringFilter']),
    ...mapGetters('user', ['hasRoleComprador', 'hasRoleRequisicao']),
    searchText: {
      get() {
        return this.$store.getters['listagemMensagens/searchText'];
      },
      set(searchText) {
        this.$store.dispatch('listagemMensagens/searchText', searchText);
      },
    },
  },
  methods: {
    onChangeSearchText() {
      this.onChangeFilter(this.stringFilter);
    },
    onSelectItem() {
      this.onChangeFilter(this.stringFilter);
    },
  },
  components: {
    pxMensagemPersonalizadaFilter: MensagemPersonalizadaFilter,
  },
};
</script>
